import styled from 'styled-components'

import { Container } from '@tribegroup'

const ToggleButton = styled(Container)`
  transition: all 0.2s ease-in-out;
`

export { ToggleButton }
